var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#3B5999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1935 21.125L24.6935 17.8674H21.5677V15.7535C21.5677 14.8623 22.0044 13.9936 23.4043 13.9936H24.8253V11.2201C24.8253 11.2201 23.5358 11 22.3028 11C19.7287 11 18.0461 12.5602 18.0461 15.3847V17.8674H15.1848V21.125H18.0461V29H21.5677V21.125H24.1935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacIcon);
export default __webpack_public_path__ + "static/media/facIcon.5b2cc562c8f7998b367dcb99f7cb154a.svg";
export { ForwardRef as ReactComponent };